const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,128}$/;

const normalizeInput = (value) => (typeof value === "string" ? value.trim() : "");

const isValidEmail = (value) => {
  const input = normalizeInput(value);
  if (!input) return false;
  if (input.length > 190) return false;
  return EMAIL_REGEX.test(input);
};

const isValidPassword = (value) => {
  const input = typeof value === "string" ? value : "";
  return PWD_REGEX.test(input);
};

const passwordStrength = (value) => {
  const input = typeof value === "string" ? value : "";
  if (!input) return { label: "", cls: "" };

  const rules = {
    length: input.length >= 8 && input.length <= 128,
    upper: /[A-Z]/.test(input),
    lower: /[a-z]/.test(input),
    digit: /\d/.test(input),
    symbol: /[^\w\s]/.test(input),
  };

  const satisfied = Object.values(rules).filter(Boolean).length;
  const allSatisfied = Object.values(rules).every(Boolean);

  if (allSatisfied) return { label: "Strong", cls: "text-success" };
  if (satisfied >= 3) return { label: "Medium", cls: "text-warning" };
  if (satisfied >= 1) return { label: "Weak", cls: "text-danger" };
  return { label: "", cls: "" };
};

export {
  EMAIL_REGEX,
  PWD_REGEX,
  isValidEmail,
  isValidPassword,
  passwordStrength,
};
